// v2/hooks/useCari.js — oturum sahibinin cari bilgisi (unvan + kod)
//
// Kaynak: GET /api/get-customer-name/  ->  {customer_name, customer_code}
// Unvan Clcard.definition'dan gelir; kullanici adi ve kod oturumdan okunur.
// Tek istek: sonuc sessionStorage'da tutulur, sayfa gecislerinde tekrar sorulmaz.
import { useState, useEffect } from 'react';
import { apiGet } from '../utils/api';
import { oturumBilgisi } from '../utils/authStore';

const ANAHTAR = 'v2_cari_bilgi';

let onbellek = null;
let bekleyen = null;

function diskten() {
  if (onbellek) return onbellek;
  try {
    const ham = window.sessionStorage.getItem(ANAHTAR);
    if (ham) {
      const v = JSON.parse(ham);
      const { user } = oturumBilgisi();
      // baska cari ile giris yapildiysa onbellegi kullanma
      if (v && user && v.kod === user.kod) {
        onbellek = v;
        return v;
      }
    }
  } catch (e) { /* bozuk kayit yok sayilir */ }
  return null;
}

function getir() {
  if (bekleyen) return bekleyen;
  bekleyen = apiGet('/get-customer-name/')
    .then((veri) => {
      const { user } = oturumBilgisi();
      const bilgi = {
        unvan: (veri && veri.customer_name) || '',
        kod: (veri && veri.customer_code) || (user ? user.kod : '') || '',
        adSoyad: user ? (user.ad_soyad || '') : '',
      };
      onbellek = bilgi;
      try {
        window.sessionStorage.setItem(ANAHTAR, JSON.stringify(bilgi));
      } catch (e) { /* kota dolu olabilir */ }
      return bilgi;
    })
    .finally(() => { bekleyen = null; });
  return bekleyen;
}

/** Oturum kapaninca onbellek de temizlensin */
export function cariOnbellegiTemizle() {
  onbellek = null;
  try { window.sessionStorage.removeItem(ANAHTAR); } catch (e) { /* yok say */ }
}

export default function useCari() {
  const { girisli, user } = oturumBilgisi();
  const [bilgi, setBilgi] = useState(() => diskten() || {
    unvan: '',
    kod: user ? (user.kod || '') : '',
    adSoyad: user ? (user.ad_soyad || '') : '',
  });

  useEffect(() => {
    if (!girisli) return undefined;
    if (diskten()) { setBilgi(diskten()); return undefined; }
    let iptal = false;
    getir()
      .then((v) => { if (!iptal) setBilgi(v); })
      .catch(() => { /* unvan bos kalir, kod oturumdan gelir */ });
    return () => { iptal = true; };
  }, [girisli, user && user.kod]);

  return bilgi;
}
